<c-card *transloco="let t">
    <c-card-body>

            <c-row>
              <c-col md="12">
                  <h1>{{ t('Your Account is no Longer Active') }}</h1>
                <p>
                    {{ t('To talk about activating your account again, please email us at ') }}<a href="mailto:customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a>.
                </p>

              </c-col>
            </c-row>
    </c-card-body>
</c-card>

